import { Shield, Phone, ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import HeaderAuth from "./HeaderAuth";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Sheet, SheetTrigger, SheetContent } from "@/components/ui/sheet";
import CartContent from "./cart/CartContent";
import { useIsMobile } from "@/hooks/use-mobile";

const Header = () => {
  const { t } = useTranslation();
  const [cartOpen, setCartOpen] = useState(false);
  
  const [cartItem, setCartItem] = useState<{
    id: string;
    name: string;
    price: string;
    description: string;
    type?: 'subscription' | 'service';
    isUpgrade?: boolean;
    currentPlanPrice?: string;
    period?: 'month' | 'year';
    stripePriceId?: string | null;
    isTrialEligible?: boolean;
  } | null>(null);
  const isMobile = useIsMobile();

  const handleRemoveFromCart = () => {
    setCartItem(null);
  };

  // Listen for addToCart events from Pricing component
  useEffect(() => {
    const handleAddToCart = (event: CustomEvent) => {
      setCartItem(event.detail);
      setCartOpen(true);
    };

    window.addEventListener('addToCart', handleAddToCart as EventListener);
    return () => window.removeEventListener('addToCart', handleAddToCart as EventListener);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/60">
      <div className="container flex h-16 items-center justify-between px-2 sm:px-4">
        <Link to="/" className="flex items-center gap-2 min-w-0 flex-shrink">
          <Shield className="h-6 w-6 sm:h-8 sm:w-8 text-primary flex-shrink-0" />
          <span className="text-lg sm:text-xl font-bold truncate">OnlineSicher24</span>
        </Link>
        
        <div className="flex items-center gap-1 sm:gap-2 md:gap-4 min-w-0">
          {/* Warenkorb Button */}
          {isMobile ? (
            <Sheet open={cartOpen} onOpenChange={setCartOpen}>
              <SheetTrigger asChild>
                <Button variant="outline" size="sm" className="relative">
                  <ShoppingCart className="h-4 w-4" />
                  {cartItem && (
                    <Badge
                      variant="destructive"
                      className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 text-xs"
                    >
                      1
                    </Badge>
                  )}
                   <span className="hidden sm:inline ml-2">{t('cart', 'Warenkorb')}</span>
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[90vw] sm:max-w-sm p-0">
                <CartContent
                  cartItem={cartItem}
                  onRemoveItem={handleRemoveFromCart}
                  onClose={() => setCartOpen(false)}
                />
              </SheetContent>
            </Sheet>
          ) : (
            <Popover open={cartOpen} onOpenChange={setCartOpen}>
              <PopoverTrigger asChild>
                <Button variant="outline" size="sm" className="relative">
                  <ShoppingCart className="h-4 w-4" />
                  {cartItem && (
                    <Badge
                      variant="destructive"
                      className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 text-xs"
                    >
                      1
                    </Badge>
                  )}
                  <span className="hidden sm:inline ml-2">{t('cart', 'Warenkorb')}</span>
                </Button>
              </PopoverTrigger>
              <PopoverContent align="end" className="w-80 p-0">
                <CartContent
                  cartItem={cartItem}
                  onRemoveItem={handleRemoveFromCart}
                  onClose={() => setCartOpen(false)}
                />
              </PopoverContent>
            </Popover>
          )}

          <HeaderAuth />
        </div>
      </div>
      
    </header>
  );
};

export default Header;